'use client';

import { Icon } from '@/general/Icons/Icon';
import { usePathname } from 'next/navigation';
import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { modalStore } from '@/stores/modalStore';

import { HeaderMenuAction } from './HeaderMenuAction';

/** Listing routes that render their own inline search bar (see `PlpSearchBar`). */
const hasInlineSearch = (pathname: string) => pathname.startsWith('/used-cars') || pathname.startsWith('/buy');

export const HeaderMenuActionSearch: FC = () => {
  const pathname = usePathname();
  const { openModal } = modalStore(
    (state) => ({
      openModal: state.openModal,
    }),
    shallow,
  );

  if (hasInlineSearch(pathname)) {
    return null;
  }

  return (
    <HeaderMenuAction title="Open search" data-testid="header-menu-button-search" onClick={() => openModal('search')}>
      <Icon name="search" />
    </HeaderMenuAction>
  );
};
